import React, { Component } from "react";
import helpers from "../../helpers";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: props.file,
    };
  }

  async componentDidMount() {
    $(".menu-hider").addClass("menu-active");
    const thumbnail = await helpers.serviceRequest("downloadPdf", {
      key: this.state.file.thumbnail,
    });
    this.setState({ thumbnail: thumbnail.presigned_url });
  }

  componentWillUnmount() {
    $(".menu-hider").removeClass("menu-active");
  }

  render() {
    return (
      <div
        id="menu-document"
        className="menu menu-box-bottom menu-active"
        data-menu-effect="menu-over"
        style={{ height: "auto" }}
      >
        <div className="top-20 center-text">
          <h2 className="uppercase bold">New Document Saved</h2>
          <p
            className="under-heading bottom-20"
            style={{ color: "#0080a2", fontSize: 15 + "px" }}
          >
            Go to printer now!
          </p>
          <div
            className="center-text-huge bottom-0"
            style={{
              background: "#f5f5f5",
              paddingTop: 20 + "px",
              paddingBottom: 10 + "px",
            }}
          >
            <img
              src={this.state.thumbnail}
              style={{
                margin: "0 auto",
                minWidth: 107 + "px",
                height: 150 + "px",
                border: "1px solid #d0d0d0",
              }}
            />
            <span className="bold" style={{ color: "black" }}>
              Pages: {this.state.file.pages}
            </span>
          </div>
          <a
            href="#"
            className="close-menu button button-s button-center-large button-round-medium shadow-large bg-highlight"
          >
            thanks
          </a>
        </div>
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/menus/document.js